import { Checkbox, Chip, Divider, FormControlLabel, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { CommentsContainer, Container } from "./styles";
import { TravelExpenseRef } from "../../../../../../../../../../../models/travel-expenses/travel-expense-ref";
import { CommentsTypes, CommentField } from "../AuditComponents/CommentField";

interface Props {
  readOnly: boolean;
  travelExpense: TravelExpenseRef;
  handleChangeField: (field: keyof TravelExpenseRef, value: TravelExpenseRef[keyof TravelExpenseRef]) => void;
}

const AuditorCommentsFields = ({ readOnly, travelExpense, handleChangeField }: Props) => {
  const tRP = "components.expense_reports";
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container>
      <Grid>
        <Divider>
          <Chip
            label={`${t(`${tRP}.audit_comments`)}`}
            size="small"
            style={{ color: theme.palette.secondary.light }}
          />
        </Divider>
      </Grid>

      <CommentsContainer>
        <FormControlLabel
          control={
            <Checkbox
              checked={travelExpense.costIncurred}
              onChange={({ target: elem }) => {
                handleChangeField("costIncurred", elem.checked);
              }}
              disabled={readOnly}
            />
          }
          label={`${t(`${tRP}.was_the_cost_really_incurred`)}`}
        />

        <>
          {readOnly && <Typography>{travelExpense.costIncurredComment}</Typography>}

          {!readOnly && (
            <>
              <CommentField
                label={`${t(`${tRP}.comment`)}`}
                customComment={travelExpense.costIncurredComment ?? ""}
                handleChangeField={(value) => handleChangeField("costIncurredComment", value)}
                commentFor={CommentsTypes.isRelatedToCostIncurred}
                travelExpenseTypeId={travelExpense.type?.id}
              />
            </>
          )}
        </>
      </CommentsContainer>
      <CommentsContainer>
        <FormControlLabel
          control={
            <Checkbox
              checked={travelExpense.amountAndTypeJustified}
              onChange={({ target: elem }) => {
                handleChangeField("amountAndTypeJustified", elem.checked);
              }}
              disabled={readOnly}
            />
          }
          label={`${t(`${tRP}.amount_and_expense_type_justified`)}`}
        />

        <>
          {readOnly && <Typography>{travelExpense.amountAndTypeJustifiedComment}</Typography>}

          {!readOnly && (
            <>
              <CommentField
                label={`${t(`${tRP}.comment`)}`}
                customComment={travelExpense.amountAndTypeJustifiedComment ?? ""}
                handleChangeField={(value) => handleChangeField("amountAndTypeJustifiedComment", value)}
                commentFor={CommentsTypes.isRelatedToAmountExpenseTypeJustification}
                travelExpenseTypeId={travelExpense.type?.id}
              />
            </>
          )}
        </>
      </CommentsContainer>
      <CommentsContainer>
        <FormControlLabel
          control={
            <Checkbox
              checked={travelExpense.compliantReceipt}
              onChange={({ target: elem }) => {
                handleChangeField("compliantReceipt", elem.checked);
              }}
              disabled={readOnly}
            />
          }
          label={`${t(`${tRP}.is_receipt_readable`)}`}
        />

        <>
          {readOnly && <Typography>{travelExpense.compliantReceiptComment}</Typography>}
          {!readOnly && (
            <>
              <CommentField
                label={`${t(`${tRP}.comment`)}`}
                customComment={travelExpense.compliantReceiptComment ?? ""}
                handleChangeField={(value) => handleChangeField("compliantReceiptComment", value)}
                commentFor={CommentsTypes.isRelatedToReceiptCompliance}
                travelExpenseTypeId={travelExpense.type?.id}
              />
            </>
          )}
        </>
      </CommentsContainer>
    </Container>
  );
};

export default AuditorCommentsFields;
